import {
  MONTH_INITIALS,
  MONTH_NAMES,
  SEASON,
  SEASON_INITIALS,
} from "../../utils/date.utils";

export const get2Year = (value: number, divisor: number, date: Date) => {
  const fullYear = date.getFullYear() + Math.floor(value / divisor);
  return fullYear.toString().substring(2);
};

export const getLongTermSeason = (date: Date) => {
  const FIRST_SEASON = Math.floor(date.getMonth() / 3);
  return (FIRST_SEASON + 2) % 4;
};
export const getLongTermInfo = (
  month: string[],
  season: string[],
  seasonFunc: (value: number, accessor: number, season: string[]) => string,
  date: Date,
) => {
  const FIRST_SEASON = Math.floor(date.getMonth() / 3);
  const LONG_TERM_SEASON = FIRST_SEASON + 2;
  return Array(4)
    .fill(0)
    .map((_, i) => {
      const value = LONG_TERM_SEASON + i;
      const accessor = value % 4;
      return seasonFunc(value, accessor, season);
    });
};
export const getVerticalHeaders = (forecast_month: Date) => {
  const seasonsFunc = (value: number, accessor: number, season: string[]) => {
    const year = get2Year(value, 4, forecast_month);
    return `${season[accessor]} ${year}`;
  };
  const seasons = getLongTermInfo(
    MONTH_INITIALS,
    SEASON_INITIALS,
    seasonsFunc,
    forecast_month,
  );
  return { verticalHeaders: seasons };
};

export const getVerticalHeadersForHistorical = (forecast_month: Date) => {
  const seasonsFunc = (value: number, accessor: number, season: string[]) => {
    return `${season[accessor]}`;
  };
  const seasons = getLongTermInfo(
      MONTH_INITIALS,
      SEASON_INITIALS,
      seasonsFunc,
      forecast_month,
  );
  return { verticalHeadersForHistorical: seasons };
};
